var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from "react";
import { renderMarketsCountLink } from "../EventCard/RenderMethods";
import * as RenderMethods from "./RenderMethods";
import { getOutrightCountLinkParams, getCardDetailsParams } from "../../../../helpers";
import { observer } from "mobx-react";
var LiveOutright = /** @class */ (function (_super) {
    __extends(LiveOutright, _super);
    /* istanbul ignore next */
    /* super transpiles to  var _this = _super.call(this) || this; */
    function LiveOutright(props) {
        var _this = _super.call(this, props) || this;
        _this.renderDetails = RenderMethods.renderOutrightDetails;
        _this.renderMarkets = RenderMethods.renderOutrightMarkets;
        _this.getCardDetailsParams = getCardDetailsParams;
        _this.getCountLinkParams = getOutrightCountLinkParams;
        _this.componentPrefix = "live-outright";
        _this.buttonsHolderClass = "rj-ev-list__" + _this.componentPrefix + "__buttons-holder";
        return _this;
    }
    LiveOutright.prototype.render = function () {
        return (React.createElement("div", { className: "rj-ev-list__" + this.componentPrefix, "data-uat": "div-ev-list-" + this.componentPrefix },
            React.createElement("div", { className: "rj-ev-list__" + this.componentPrefix + "__inner", "data-uat": "div-ev-list-" + this.componentPrefix + "-inner" },
                this.renderDetails(this.getCardDetailsParams(this.props), this.componentPrefix),
                this.renderMarkets(this.props, this.buttonsHolderClass, this.componentPrefix),
                renderMarketsCountLink(this.getCountLinkParams(this.props), this.componentPrefix))));
    };
    LiveOutright = __decorate([
        observer,
        __metadata("design:paramtypes", [Object])
    ], LiveOutright);
    return LiveOutright;
}(React.Component));
export { LiveOutright };
//# sourceMappingURL=LiveOutright.js.map